import { FunctionComponent as F, ReactNode } from "react";
import Typography from '@mui/material/Typography';
import { composeTaxBreakdown } from "../../utils/string";
import TextTooltip from "../UI/Tooltip/TextTooltip";
import priceUpdateStatusLines from '../Listings/priceUpdateStatusLines';
import { useSelector } from "react-redux";
import { IState } from "../../core/store/store";

interface Props
{
  protocolId: number,
  dosingId: number,
  colour: string
}

const CostPerMonth: F<Props> = props =>
{
  const row = useSelector((state: IState) => state.protocol.protocols
    .find(p => p.protocolId === props.protocolId)?.dosings
    ?.find(d => d.dosingId === props.dosingId));
  const protocolCurrencySymbol = useSelector((state: IState) => state.protocol.protocols
    .find(p => p.protocolId === props.protocolId)?.currencySymbol);
  const userCurrencySymbol = useSelector((state: IState) => state.user.currencySymbol);
  const protocolFees = useSelector((state: IState) => state.protocol.protocols
    .find(p => p.protocolId === props.protocolId)?.fees);

  if(!row || !protocolCurrencySymbol)
    return <></>;


  if(
    row.price === undefined ||
    !row.quantity ||
    row.costPerMonthWithFees === undefined ||
    row.costPerMonthWithoutFees === undefined)
  {
    return (
      <Typography
        className={props.colour}
        variant='body2'
        textAlign='right'
        sx={{ color: props.colour }}>
        {"-"}
      </Typography>);
  }

  let tooltipTextLines: ReactNode[] = [(row.bundleId ?
    "Listed price per bundle: " :
    ("Listed price per " + row.amount + " " + row.amountUnit + ": ")) +
      row.listingCurrencySymbol + row.price.toFixed(2)];

  if(row.exchangeRate && row.exchangeRate !== 1)  // exchange rate
  {
    tooltipTextLines.push(
      "@" + row.listingCurrencyCode + "->" +
        row.protocolCurrencyCode + " " + row.exchangeRate.toFixed(3));
  }
  if(protocolFees && row.deliveryPerListing)  // delivery per listing
  {
    tooltipTextLines[0] += " + " + row.listingCurrencySymbol + row.deliveryPerListing.toFixed(2) + " delivery";
  }
  if(protocolFees && row.deliveryPrice) // delivery per order
  {
    tooltipTextLines.push(
      "+" + row.vendorCurrencySymbol + row.deliveryPrice.toFixed(2) +
      " delivery per order" + (row.deliveryPriceEstimated ? " (est.)" : ""));
  }
  if(protocolFees && (row.baseTax || row.taxPercent)) // tax
  {
    tooltipTextLines.push(composeTaxBreakdown(
      { ...row, baseTax: Number(row.baseTax) },
      userCurrencySymbol) || "");
  }
  if(row.scrapeTime)  // scrape time
  {
    tooltipTextLines.push(priceUpdateStatusLines(row.scrapeTime));
  }

  const render = (value?: number) => (
    <TextTooltip
      children={
        <Typography
          className={props.colour}
          variant='body2'
          textAlign='right'
          sx={{ color: props.colour }}>
          {typeof value === "number" ? value.toFixed(2) : "-"}
        </Typography>}
      lines={tooltipTextLines} />);

  return render(protocolFees ? row.costPerMonthWithFees : row.costPerMonthWithoutFees);
};




export default CostPerMonth;
